import { render, staticRenderFns } from "./IsFeastedDialog.vue?vue&type=template&id=387b734e&"
import script from "./IsFeastedDialog.vue?vue&type=script&lang=js&"
export * from "./IsFeastedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports